import { render, staticRenderFns } from "./ApiTokenUpdateDialog.vue?vue&type=template&id=35493cc8"
import script from "./ApiTokenUpdateDialog.vue?vue&type=script&lang=js"
export * from "./ApiTokenUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports